import dashboard from './dashboard';
import listing from './listing';
import map from './map';
import ripple from './ripple';
import personal from './personal';
import documentation from './documentation';
import admin from './admin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [listing, map, ripple, personal, documentation]
};

export default menuItems;
